import { Container } from '@pixi/react'
import { gameConfig } from '../config'
import { AutoButtonV2, useAutoPlayStore, useIsSpinning } from '@slot-nx/core'
import { useCallback, useMemo } from 'react'
import { Bet } from './Bet'
import { SpinButton } from './SpinButton'
import { SpeedButton } from './SpeedButton'
import { Menu } from './menu/Menu'
import { useSelector } from '@xstate/react'
import { GameState, MachineActionType, sweetBombMachine } from '../../machine/sweetbombMachine'
import { spinService } from '../domain/game'
import { useGameStore } from '../domain/game/store/GameStore'
import { GodziSpinButton } from './godziDrop/GodziSpinButton'
import { useGodziDropStore } from '../domain/godziDrop/store/godziDropStore'

interface ControlGroupProps {
  x: number
  y: number
}

export const ControlGroup = (props: ControlGroupProps) => {
  const width = gameConfig.resolution.width - 192
  const height = 216
  const startX = 96

  const isSpinning = useIsSpinning()
  const isDisableEmergencyStop = useGameStore.getState().isDisableEmergencyStop

  const currentState = useSelector(sweetBombMachine, state => state)
  const { isFreeGame } = useGameStore()
  const { isPlaying } = useAutoPlayStore()
  const { isGodziTime } = useGodziDropStore()

  const onSpin = useCallback(() => {
    if (currentState.matches(GameState.mainGame) || currentState.matches({ voucher: GameState.voucherTime })) {
      sweetBombMachine.send({ type: MachineActionType.placeOrder })
    }
  }, [currentState])

  const onSpinningCallback = useCallback(() => {
    spinService.emergencyStop()
  }, []) // currentState

  const autoButtonEnabled = useMemo(() => {
    if (currentState.matches(GameState.mainGame)) {
      return true
    }
    else if (isFreeGame) {
      return false
    }
    else if (isPlaying) {
      return false
    }
    else if (currentState.matches(GameState.godziEntry) || isGodziTime) {
      return false
    }
    else {
      return true
    }
  }, [isFreeGame, currentState, isPlaying, isGodziTime])

  const spinBtnEnabled = useMemo(() => {
    if (isFreeGame) {
      return false
    }
    else if ((currentState.matches(GameState.mainGame) || currentState.matches(GameState.displayGameResult) || currentState.matches({ voucher: GameState.voucherTime })) && !isDisableEmergencyStop) {
      return true
    }
    else {
      return false
    }
  }, [currentState, isDisableEmergencyStop, isFreeGame])

  return (
    <Container name="ControlGroup" x={props.x}>
      <SpinButton
        x={(width - 216) / 2 + startX}
        y={props.y}
        width={216}
        height={216}
        isSpinning={isSpinning}
        onSpin={onSpin}
        onSpinning={onSpinningCallback}
        enabled={spinBtnEnabled}
      />
      <GodziSpinButton
        x={(width) / 2 - 20}
        y={props.y - 200}
      />
      <Bet x={(width - 452) / 2 + startX} y={props.y + 69} />
      <AutoButtonV2 enabled={autoButtonEnabled} x={width - 72} y={props.y + (height - 120) / 2} width={120} />
      <SpeedButton
        name="speed button"
        x={140}
        y={props.y + 47}
        width={120}
        height={120}
      />

      <Menu
        x={0}
        y={props.y + 30}
        // historyDisabled={!currentState.matches('init game')}
        speedBtnDisabled={false}
      />
    </Container>
  )
}
